export default __webpack_public_path__ + "static/media/image.mint-hrm.4a9b4b66.png";